import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from 'lucide-react';
import type { Course } from '../../types/content';
import { BOOKING_URL } from '../../data/site';
import { coursePath, priceLabel } from '../../utils/courses';
import { ImageSlot } from '../ui/ImageSlot';
import { ButtonLink } from '../ui/ButtonLink';
export function CourseCard({
  course
}: {
  course: Course;
}) {
  const path = coursePath(course);
  return <article className="group relative flex h-full flex-col overflow-hidden rounded-[4px] bg-white shadow-[0_1px_0_rgba(16,32,72,0.08),0_8px_24px_-12px_rgba(16,32,72,0.25)] ring-1 ring-navy/10 transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-1 hover:shadow-[0_18px_40px_-16px_rgba(16,32,72,0.45)]" data-id="element-66" data-mp="14zbjgckogise">
      <div className="relative" data-id="element-67" data-mp="3fs60ya0uga8e">
        <ImageSlot image={course.image} className="aspect-[16/10]" imgClassName="transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-68" data-mp="3fsecnyl8d9i0" />
        <span className="absolute left-3 top-3 rounded-[3px] bg-navy px-2.5 py-1 font-display text-xs font-semibold tracking-[0.12em] text-white ring-1 ring-chrome-300/40" data-id="element-69" data-mp="3bsne38pgpp2x">
          {course.code}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5 lg:p-6" data-id="element-70" data-mp="68y0xcmy6zw4">
        <h3 className="t-h3 text-navy" data-id="element-71" data-mp="68eilutdy9hk">
          <Link to={path} className="after:absolute after:inset-0 focus:outline-none" data-id="element-72" data-mp="a9zqt2uz5zlf">
            {course.name}
          </Link>
        </h3>
        <p className="mt-2 text-[15px] leading-relaxed text-steel" data-id="element-73" data-mp="3snh5yiq192px">{course.benefit}</p>
        <div className="mt-auto pt-5" data-id="element-74" data-mp="1amqp0sqqndd">
          <div className="flex items-end justify-between gap-3 border-t border-navy/10 pt-4" data-id="element-75" data-mp="1bo59f8ytrzu">
            <span className="flex items-center gap-1.5 text-sm text-steel" data-id="element-76" data-mp="3inzzw06vcmtf">
              <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="3npxnt7q7s5sp" />
              {course.duration}
            </span>
            <span className="font-display text-2xl font-semibold text-navy" data-id="element-78" data-mp="39q6f9migvhm3">{priceLabel(course)}</span>
          </div>
          <div className="relative z-10 mt-4 grid grid-cols-2 gap-2" data-id="element-79" data-mp="3eqamelxhizzn">
            <ButtonLink href={BOOKING_URL} size="sm" ariaLabel={`Book ${course.name}`} data-id="element-80" data-mp="1k9u3ah9qudvq">
              Book Now
            </ButtonLink>
            <ButtonLink to={path} size="sm" variant="outline-dark" ariaLabel={`${course.name} details`} data-id="element-81" data-mp="1aifzvyeo8txb">
              Details
            </ButtonLink>
          </div>
        </div>
      </div>
      <span className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 bg-accent transition-transform duration-200 ease-out group-hover:scale-x-100" aria-hidden="true" data-id="element-82" data-mp="16f1ib3b345hr" />
    </article>;
}